import {
  FETCH_ALL_PRODUCT_TYPES,
} from './../../mutation-types';

export default {
  [FETCH_ALL_PRODUCT_TYPES](state, productTypes) {
    state.all = productTypes;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/productType/mutations.js